import answerController from "../../../controllers/answerController/controller";
import Swal from 'sweetalert2';
import { EventBus } from "@/eventBus";
export default {
    name: 'SimpleTable',
    data() {
        return{
            company: '',
            answerList:[],
            currentPage: 1,
            pageSize: 10,
            totalAnswer: 0,
            totalPages: 0,
            searchQuery: '',
            sizes: [1, 5, 10, 20],
            answer:{
                id: '',
                answer: '',
                answer_type: '',
                language: '',
                score: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
                status: ''
            },
            selectedAnswer: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed: {
        filteredAnswer(){
            return this.answerList.filter((answer) => {
                return answer.answer.toLowerCase().includes(this.searchQuery.toLowerCase())
            })
        },
        pages(){
            return Math.ceil(this.totalAnswer / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.answer.created_by = id;
            this.selectedAnswer.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.answer.created_by_name = name;
            this.selectedAnswer.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const answer = this.answerList.find(answer => answer.id === id);
            if (answer) {
                this.answer = answer;
                
                const modal = document.getElementById(type === 'edit' ? 'editAnswer' : 'detailAnswer');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahAnswer', 'editAnswer', 'detailAnswer'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.getAnswer();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.answer.answer = '';
            this.answer.answer_type = '';
            this.answer.language = '';
            this.answer.score = '';
            this.answer.status = '';
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.getAnswer();
            }
        },
        async getAnswer() {
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await answerController.getAnswer(query, this.currentPage, this.pageSize, company);
                this.answerList = response.data;
                this.totalAllAnswer();
            } catch (error){
                console.error('Error fetching answers:', error);
            }
        },
        async totalAllAnswer() {
            try{
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await answerController.totalAllAnswer(query, company);
                this.totalAnswer = response;
            } catch (error){
                console.error('Error fetching answers:', error);
            }
        },
        async addAnswer() {
            try {
                const answer = this.answer.answer;
                const answer_type = this.answer.answer_type;
                const score = this.answer.score;
                const language = this.answer.language;
                const company = this.company;
                const is_active = this.answer.status;
                const created_by = this.answer.created_by;
                const created_by_name = this.answer.created_by_name;
                if (!answer || !answer_type || !score || !language || !is_active || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    answer: answer,
                    answer_type: answer_type,
                    score: score,
                    language: language,
                    id_company : company,
                    is_active: is_active,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    created_on: created_on
                }
                await answerController.addAnswer(add);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Answer berhasil ditambahkan',
                    timer: 1500
                })
                this.closeModal();
                this.resetForm();
                this.getAnswer();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan',
                    timer: 1500
                })
            }
        },
        async updateAnswer() {
            try {
                const id = this.answer.id;
                const answer = this.answer.answer;
                const answer_type = this.answer.answer_type;
                const score = this.answer.score;
                const language = this.answer.language;
                const is_active = this.answer.status;
                const updated_by = this.selectedAnswer.updated_by;
                const updated_by_name = this.selectedAnswer.updated_by_name;
                if (!id || !answer || !answer_type || !language || !score || !is_active || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const update = {
                    id: id,
                    answer: answer,
                    answer_type: answer_type,
                    score: score,
                    language: language,
                    is_active: is_active,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                }
                await answerController.updateAnswer(update);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Answer berhasil diperbaharui',
                    timer: 1500
                })
                this.closeModal();
                this.getAnswer();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan',
                    timer: 1500
                })
            }
        },
        async deleteAnswer(id) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await answerController.deleteAnswer(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Answer berhasil dihapus',
                        timer: 1500
                    })
                    this.getAnswer();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Terjadi kesalahan',
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
            console.log("Company updated in HelloWorld.vue:", this.company);
        }
    },
    mounted() {
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch:{
        searchQuery: {
            handler: 'getAnswer'
        },
        company: {
            handler: 'getAnswer'
        }
    },
}